import React, { PropsWithChildren } from 'react';

import { Box } from '@mui/material';

const DrawerFooter: React.FC<PropsWithChildren<object>> = ({ children }) => {
  return (
    <Box
      px={2.5}
      pb={2.5}
      pt="15px"
      display="flex"
      alignItems="flex-end"
      borderTop="1px solid #E0E0E0"
      sx={{ position: 'absolute', bottom: 0, left: 0, right: 0 }}
    >
      <Box display="inline-flex" gap={3} ml="auto">
        {children}
      </Box>
    </Box>
  );
};

export default DrawerFooter;
